import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'session-nav',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent {
  @Input() icon = '';
  @Input() glyph = '';
  @Input() active = false;
  @Output() selected = new EventEmitter();

  get iconClass() {
    return this.glyph ? `fa fa-${this.glyph}` : `icon-${this.icon}`;
  }
}
